export const isEmpty = (item = '') => {
    return item.trim() === '';
};

export const replaceKeysWithValues = (inputString, replacements) => {
    if (!inputString) return "";
    let resultString = inputString;

    for (const key in replacements) {
        if (replacements.hasOwnProperty(key)) {
            const regex = new RegExp(key, 'g'); // 'g' flag for global matching
            resultString = resultString.replace(regex, replacements[key]);
        }
    }

    return resultString;
}


export const getAlliterativeName = (string) => {
    if (!string) return "";
    let result = [];
    for (let word of string.split(' ')) {
        if (word) {
            result.push(word[0].toUpperCase());
        }
        if (result.length === 2) break;
    }

    return result.join('');
}
